import {deleteAsync, patchAsync} from '../../../services/http/http';
import {ThunkAction, ThunkAsyncAction} from '../../appThunk';
import {AnswerFolderActionsEnum, AnswerFoldersDeletedAction} from '../answerFolders/answerFolderActions';
import {getCompany} from '../company/companySelectors';
import {AnswerActionsEnum, AnswersDeletedAction} from './answerActions';

export function deleteAnswersOrFolderBulkAsync(
  namespace: string,
  folderIds: ReadonlyArray<number>,
  answerIds: ReadonlyArray<number>,
): ThunkAsyncAction {
  return async (dispatch, getState) => {
    const company = getCompany(getState());

    const url = `${company.url}/namespaces/${namespace}/canned_answers_batch`;

    try {
      const body = {
        folder_ids: folderIds,
        answer_ids: answerIds,
      };

      await deleteAsync(url, body);

      dispatch<AnswersDeletedAction>({
        type: AnswerActionsEnum.ANSWERS_DELETED,
        payload: answerIds,
      });
      dispatch<AnswerFoldersDeletedAction>({
        type: AnswerFolderActionsEnum.ANSWER_FOLDERS_DELETED,
        payload: folderIds,
      });
    } catch (e) {
      console.error(e);
    }
  };
}

export function deleteAnswerAndFoldersBulkPushAction(
  answerIds: ReadonlyArray<number>,
  folderIds: ReadonlyArray<number>,
): ThunkAction {
  return (dispatch) => {
    dispatch<AnswersDeletedAction>({
      type: AnswerActionsEnum.ANSWERS_DELETED,
      payload: answerIds,
    });
    dispatch<AnswerFoldersDeletedAction>({
      type: AnswerFolderActionsEnum.ANSWER_FOLDERS_DELETED,
      payload: folderIds,
    });
  };
}

export function moveAnswersOrFolderBulkAsync(
  namespace: string,
  destinationFolderId: number | undefined,
  folderIds: ReadonlyArray<number>,
  answerIds: ReadonlyArray<number>,
): ThunkAsyncAction {
  return async (_dispatch, getState) => {
    const company = getCompany(getState());

    try {
      const url = `${company.url}/namespaces/${namespace}/canned_answers_batch`;
      const body = {
        parent_folder_id: destinationFolderId,
        folder_ids: folderIds,
        answer_ids: answerIds,
      };

      await patchAsync(url, body);
    } catch (e) {
      console.error(e);
    }
  };
}
